import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"saturation"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M5.63603 20.3882C9.15075 23.8697 14.8492 23.8697 18.364 20.3882C21.8787 16.9067 21.8787 11.262 18.364 7.78044L12 1.47656L5.63603 7.78044C2.12131 11.262 2.12131 16.9067 5.63603 20.3882Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M12 10.0349C14.4751 10.0349 16.4816 12.0413 16.4816 14.5164C16.4816 16.9916 14.4751 18.998 12 18.998C12.0001 17.1752 12 12.7109 12 10.0349Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5.63603 20.3882C9.15075 23.8697 14.8492 23.8697 18.364 20.3882C21.8787 16.9067 21.8787 11.262 18.364 7.78044L12 1.47656L5.63603 7.78044C2.12131 11.262 2.12131 16.9067 5.63603 20.3882Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 10.0349C14.4751 10.0349 16.4816 12.0413 16.4816 14.5164C16.4816 16.9916 14.4751 18.998 12 18.998C12.0001 17.1752 12 12.7109 12 10.0349Z","strokeWidth":"props.strokeWidth"}}]}]};

const Saturation = Vue.extend<IconProps>({
  name: 'SaturationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'saturation',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Saturation;
